import API from "@/api/lib/api";

export const getAllVariants = async (restaurant_id, menu_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/variants/${menu_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleVariantById = async (id) => {
  try {
    const response = await API.get(`restaurant/variants/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createVariant = async (data) => {
  try {
    const response = await API.post(`restaurant/variants`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateVariant = async (id, data) => {
  try {
    const response = await API.put(`restaurant/variants/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteVariant = async (id) => {
  try {
    const response = await API.delete(`restaurant/variants/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};